
import React from 'react';

const Mission: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#001E3C] to-[#003366] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">CEO Message</h2>
            <div className="w-24 h-1 bg-[#00D9C9] mx-auto"></div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 mb-12">
            <p className="text-lg leading-relaxed mb-6">
              Since our establishment, as a gun drilling machine manufacturer, we have continuously improved and developed our gun drilling machines while refining our processing technology, always listening to the voices of our diverse customers.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              Through our commitment to technological innovation in deep hole processing, we have established world-class deep hole processing technology rarely seen globally, including achieving deep hole processing of φ1mm × 400mm depth.
            </p>
            <p className="text-lg leading-relaxed">
              With the deep hole processing technology cultivated in Japan, we are advancing global expansion through overseas machine sales projects, contributing to the improvement of manufacturing technology worldwide.
            </p>
            <div className="mt-8 text-right">
              <p className="text-xl font-semibold">Hidenori Inada</p>
              <p className="text-[#00D9C9]">Representative Director</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#00D9C9] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-focus-3-line text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Precision First</h3>
              <p className="text-gray-300">
                Achieving world-class precision in deep hole processing with innovative technology
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#00D9C9] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Continuous Innovation</h3>
              <p className="text-gray-300">
                Constantly improving our machines and techniques to meet evolving customer needs
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#00D9C9] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Global Contribution</h3>
              <p className="text-gray-300">
                Expanding worldwide to advance manufacturing technology across the globe
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
